<script lang="ts">
  import { socialLabels } from "../lang";
  import Button from "./Button.svelte";
  import Icon from "./Icon.svelte";

  const links = [
    {
      href: "https://www.steuerzahler.de/kontakt/",
      label: socialLabels.contact,
      icon: "contact",
    },
    {
      href: "https://www.steuerzahler.de/newsletter/",
      label: socialLabels.newsletter,
      icon: "newsletter",
    },
    {
      href: "https://www.facebook.com/bunddersteuerzahler/",
      label: socialLabels.facebook,
      icon: "facebook",
    },
    {
      href: "https://twitter.com/HolznagelReiner",
      label: socialLabels.twitter,
      icon: "twitter",
    },
  ] as const;
</script>

<div class="Social">
  <Button
    tag="a"
    href="https://www.steuerzahler.de/mitglied-werden/"
    appearance="white"
  >
    {socialLabels.member}
  </Button>

  {#each links as link}
    <a
      class="Social-link"
      href={link.href}
      aria-label={link.label}
      title={link.label}
    >
      <Icon type={link.icon} />
    </a>
  {/each}
</div>

<style>
  .Social {
    display: flex;
    flex-wrap: wrap;
    gap: var(--size-15);
  }

  .Social-link {
    --size: 2.375rem;

    align-items: center;
    block-size: var(--size);
    border: var(--size-2) solid currentColor;
    border-radius: 50%;
    color: inherit;
    display: flex;
    font-size: var(--size-20);
    inline-size: var(--size);
    justify-content: center;
  }
</style>
